import waitForLoad from "../utils/waitForLoad";
var domain = 'https://userlike-cdn-widgets.s3-eu-west-1.amazonaws.com';
/* eslint-disable */
var loadScript = function loadScript(providerKey) {
  if (window.userlike) return false;
  var d = document;
  function l() {
    var _x$parentNode;
    var s = d.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.src = "".concat(domain, "/").concat(providerKey, ".js");
    var x = d.getElementsByTagName('script')[0];
    (_x$parentNode = x.parentNode) === null || _x$parentNode === void 0 ? void 0 : _x$parentNode.insertBefore(s, x);
  }
  l();
  return true;
};
/* eslint-enable */

var load = function load(_ref) {
  var providerKey = _ref.providerKey,
    setState = _ref.setState,
    _ref$beforeInit = _ref.beforeInit,
    beforeInit = _ref$beforeInit === void 0 ? function () {
      return undefined;
    } : _ref$beforeInit,
    _ref$onReady = _ref.onReady,
    onReady = _ref$onReady === void 0 ? function () {
      return undefined;
    } : _ref$onReady;
  var loaded = loadScript(providerKey);
  // Continue as long as userlike hasn’t already been initialised.
  if (loaded) {
    beforeInit();
    waitForLoad(function () {
      return !!window.userlike;
    },
    // Allow userlike to complete loading before removing fake widget
    function () {
      return setTimeout(function () {
        setState('complete');
        onReady();
      }, 2000);
    });
  }
  return true;
};
var open = function open() {
  waitForLoad(function () {
    var _window$userlike;
    return !!((_window$userlike = window.userlike) !== null && _window$userlike !== void 0 && _window$userlike.userlikeStartChat);
  },
  // userlike is slow to show once it has loaded
  function () {
    return setTimeout(window.userlike.userlikeStartChat, 1000);
  });
};
export default {
  domain: domain,
  load: load,
  open: open
};